import axios from 'axios';

export function deleteAdvertiserCategory(categoryId, token) {
    return axios.delete(process.env.REACT_APP_API_URL + `/advertiserCategory/${categoryId}`, {
        headers: {
            Authorization: `${token}`
        }
    });
}
